import { createAnalytics } from '@waedo/frontend-core/analytics';
export type { AnalyticsEventData, JsonValue, JsonPrimitive } from '@waedo/frontend-core/analytics';

const analytics = createAnalytics({
  app: 'portal',
  versionPath: '/footer-version.json',
  enabled: !import.meta.env.DEV && import.meta.env.MODE !== 'test'
    && (!import.meta.env.VITE_APP_ENV || import.meta.env.VITE_APP_ENV === 'production')
    && import.meta.env.VITE_IS_STAGING !== 'true'
    && import.meta.env.VITE_IS_DEVELOPMENT !== 'true',
  websiteId: import.meta.env.VITE_UMAMI_WEBSITE_ID,
  scriptUrl: import.meta.env.VITE_UMAMI_SCRIPT_URL,
});

export const { trackEvent, trackPageView, identifyUser, clearUser } = analytics;
